const defaultNavState = { modalOpen: false }

export const NAME = 'nav'
export function navReducer (state=defaultNavState, action) {
  const { type, payload } = action
  switch (type) {
    case 'SHOW_SUGGEST_MODAL':
    case 'HIDE_SUGGEST_MODAL':
    case 'TOGGLE_SUGGEST_MODAL':
      return {...state, ...payload}
    default:
      return state
  }
}

const reducer = 'default'
export default {
  constants: {NAME: NAME},
  reducers: {[reducer]: navReducer}
}
